/* istanbul ignore file */

import { createSlice } from '@reduxjs/toolkit';

export const messageSlice = createSlice({
	name: 'messages',
  	initialState: {
		msgIdx: 0,
    	messageList: [],
    	cachedMessages: []
  	},
  	reducers: {
		addMessage: (state, msg) => {
			let newMsg = msg.payload;
			newMsg.msgIdx = state.msgIdx;
			newMsg.time = 0;
			state.msgIdx++;
			state.messageList = state.messageList.concat(newMsg);
			if (state.cachedMessages.length === 10)	state.cachedMessages.splice(9, 1); 
			if (state.cachedMessages.length === 0) state.cachedMessages = state.cachedMessages.concat({...newMsg, timestamp: Date.now()});
			else state.cachedMessages.splice(0, 0, {...newMsg, timestamp: Date.now()});
		},
		removeMessage: (state, idxToRemove) => {
			let mArray = [];
			for (let i = 0; i < state.messageList.length; i++) 
				if (state.messageList[i].msgIdx !== idxToRemove.payload)
					mArray.push(state.messageList[i]);
			state.messageList = mArray;
		},
		messageTimer: (state, timeout) => {
			let mArray = [];
			for (let i = 0; i < state.messageList.length; i++)
				if (state.messageList[i].time <= timeout.payload) {
					let msg = state.messageList[i];
					msg.time += 1;
					mArray.push(msg);
				}
			state.messageList = mArray;
		},
		clearCachedMessages: (state) => {
			state.cachedMessages = [];
		},
		removeCachedMessage: (state, idxToRemove) => {
			let mArray = [];
			for (let i = 0; i < state.cachedMessages.length; i++) 
				if (state.cachedMessages[i].msgIdx !== idxToRemove.payload)
					mArray.push(state.cachedMessages[i]);
			state.cachedMessages = mArray;
		}
  	},
});

// Action creators are generated for each case reducer function
export const { addMessage, removeMessage, removeCachedMessage, clearCachedMessages, messageTimer } = messageSlice.actions;

export default messageSlice.reducer;